import { render, staticRenderFns } from "./SeminarEntryMessageRegisterConfirm.vue?vue&type=template&id=20d7669a"
import script from "./SeminarEntryMessageRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageRegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports